import i18n from './index'

export function mergeLocaleMessage (state, items) {
  const newslist = items.newslist.reduce(
                        (map, news) => Object.assign(map, { [news.news_id]: news }),
                        {}
                      )

  const list_type_news = [
    { locale: 'ja', suffix: '' },
    { locale: 'en', suffix: 'en_' },
    { locale: 'np', suffix: 'np_' },
    { locale: 'vn', suffix: 'vn_' },
    { locale: 'th', suffix: 'th_' },
    { locale: 'id', suffix: 'id_' },
    { locale: 'es', suffix: 'es_' },
    { locale: 'pt', suffix: 'pt_' },
    { locale: 'kr', suffix: 'kr_' },
    { locale: 'cn', suffix: 'cn_' },
    { locale: 'tw', suffix: 'tw_' },
    { locale: 'ru', suffix: 'ru_' },
    { locale: 'ua', suffix: 'ua_' },
  ]

  _.map(list_type_news, ({locale, suffix}) => {
    i18n.mergeLocaleMessage(locale, {
      news: _.mapValues(newslist, news => {
        const attributes = [
          'title',
          'detail',
        ]
        let result = _.zipObject(attributes, _.map(attributes, attribute => {
            return _.get(news, `${suffix}${attribute}`, '') ? _.get(news, `${suffix}${attribute}`, '') : _.get(news, `${attribute}`, '')
        }))
        return result
      })
    })
  })
}
